import React from "react";
import styled from "styled-components";
import { Heading3, Heading2 } from '../../theme/themeComponents/fonts';

interface BasicCardProps {
  title?: string;
  titleSeparator?: boolean;
  borderRadius?: string;
  horizontalAlign?: boolean;
}

const BasicCard: React.FC<BasicCardProps> = ({
  children,
  title,
  titleSeparator,
  borderRadius,
  horizontalAlign
}) => {
  return (
    <Container borderRadius={borderRadius}>
      {title && <Title>{title}</Title>}
      {titleSeparator && (
        <SeparatorSectionContainer>
          <SeparatorSectionForm />
        </SeparatorSectionContainer>
      )}
      {horizontalAlign ?
        <div style={{ display: 'flex', flexDirection: 'row' }}>
          {children}
        </div>
          :
        children}
    </Container>
  );
};

export default BasicCard;

const Container = styled.div<{ borderRadius?: string }>`
  width: 100%;
  height: 100%;
  padding: 50px 60px;
  background: #FDFAF6;
  box-shadow: -6px -6px 12px 0.5px rgba(197, 197, 197, 0.21),
    6px 6px 12px 0.5px rgba(197, 197, 197, 0.21);
  border-radius: 48px;
`;

const Title = styled.div`
  margin-bottom: 9px;
  ${Heading2};

  @media screen and (max-width: ${(props) =>
      props.theme.breakpoints.laptop13Max}) {
    ${Heading3}
  } ;
`;

const SeparatorSectionContainer = styled.div`
  margin: 5px 0;
`;

const SeparatorSectionForm = styled.div`
  width: 100%;
  height: 3px;
  background: linear-gradient(135.02deg, #095c66 0%, #209aa2 100%);
  border-radius: 6px;
`;
